// extracted by mini-css-extract-plugin
module.exports = {"labelValue":"ReportPhotoModal--label-value--3OxJM","labelExample":"ReportPhotoModal--label-example--3s3AI","reportedPhotoMessage":"ReportPhotoModal--reported-photo-message--2R_Ib"};